<!-- Base.Radio.vue (client) -->
<template tag="클라이언트 라디오 컴포넌트">
  <p class="radio_row">
    <label>
      <input v-model="model" type="radio" :name="name" :value="value" :disabled="disabled" />
      <span v-if="$slots.default"><slot></slot></span>
    </label>
  </p>
</template>
<script setup lang="ts">
/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const model = defineModel<string>({ default: "" });

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
defineProps({
  name: { type: String, default: "" }, // 라디오 이름
  value: { type: String, default: "" }, // 라디오 값
  disabled: Boolean, // 라디오 비활성화 여부
});
</script>
